import styles from './SlidevNavCircle.module.scss';
import { forwardRef } from 'react';
import { useSwiper } from 'swiper/react';

type Props = {
  direction: string;
  className: string;
};

const SliderNavCircle = forwardRef<HTMLButtonElement, Props>(function Renderer(
  { direction, className }: Props,
  ref
) {
  const swiper = useSwiper();
  const handleClick = () => {
    if (direction === 'right') {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }
    swiper.update();
  };
  return (
    <button
      onClick={() => handleClick()}
      ref={ref}
      aria-label={`Slide ${direction}`}
      className={`btn btn-primary button-label ${styles['slider-nav']} ${className}`}
    >
      <em className={`d-flex bi-chevron-${direction}`} aria-hidden={true} />
    </button>
  );
});

export default SliderNavCircle;
